/* kunstli-inkybay-cart-drawer.js
 *
 * Purpose : Make InkyBay's add-to-cart open the theme's cart drawer
 *           instead of redirecting to /cart, and leave the Buy Blank
 *           button working for the next add. No page reload.
 *
 * Search tag: KUNSTLI-INKYBAY-DRAWER
 *
 * How it hooks in (from InkyBay's own inkybay.js):
 *   After a successful add, InkyBay's afterInkybayAddToCart() checks
 *   for a global function named afterInkybayAddToCartActionWithoutRefreash
 *   (InkyBay's spelling). If it exists, InkyBay calls it INSTEAD of
 *   redirecting to /cart. This file defines that function.
 *   InkyBay's own add, retry and design-data logic is left untouched.
 *
 * Why the button used to die after one add:
 *   On products with InkyBay options, Buy Blank sets the global flag
 *   notPackingInkybayOptions = false and never sets it back (the /cart
 *   redirect used to hide that). On the next click InkyBay sees the
 *   flag, logs "Wait For Load" and adds nothing. We set it back to true.
 *   We also reset InkyBay's retry counter and remove its spinner the
 *   same way InkyBay itself does.
 *
 * Fallbacks (send the customer to /cart, i.e. the old behaviour):
 *   - no <cart-drawer> element on the page
 *   - cart drawer not yet upgraded by the theme's custom element
 *   - any error while opening the drawer
 */
(function () {
  'use strict';

  var CART_URL = (window.theme && theme.routes && theme.routes.cart) || '/cart';
  var BUTTON_IDS = ['EFOLI_BUY_BLANK_BUTTON', 'EFOLI_BUY_OPTION_BUTTON'];

  // Open the drawer straight away and let its contents update a moment
  // later. Set to false to wait for the refresh first (no flash of the
  // old cart contents, but feels slower).
  var OPEN_IMMEDIATELY = true;

  function goToCart() {
    window.location.href = CART_URL;
  }

  /* ---------- Reset InkyBay so the next add works ---------- */

  function resetInkybay() {
    try {
      // The lock that blocked the second Buy Blank click.
      window.notPackingInkybayOptions = true;
      // InkyBay's add-to-cart retry counter (it only retries while < 7).
      window.inkybayFinalPostTimes = 0;
    } catch (e) {
      console.error('KUNSTLI-INKYBAY-DRAWER reset failed:', e);
    }

    BUTTON_IDS.forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;

      // InkyBay's spinner markup is: <span>svg</span><span style="opacity:0.2">ORIGINAL</span>
      // Put ORIGINAL back, exactly as InkyBay does when it resets itself.
      var original = btn.querySelector(':scope > span[style*="opacity"]');
      if (original && btn.querySelector(':scope > span > svg')) {
        btn.innerHTML = original.innerHTML;
      }
      btn.style.pointerEvents = 'all';
    });
  }

  /* ---------- Cart drawer ---------- */

  function openDrawer() {
    resetInkybay();

    var drawer = document.querySelector('cart-drawer');

    if (!drawer || typeof drawer.refresh !== 'function' || typeof drawer.open !== 'function') {
      goToCart();
      return;
    }

    try {
      if (OPEN_IMMEDIATELY) drawer.open();

      // refresh(true) re-renders the drawer contents and the cart count bubble.
      Promise.resolve(drawer.refresh(true))
        .then(function () {
          if (!OPEN_IMMEDIATELY) drawer.open();
        })
        .catch(function (error) {
          console.error('KUNSTLI-INKYBAY-DRAWER refresh failed:', error);
          if (!OPEN_IMMEDIATELY) goToCart();
        });
    } catch (error) {
      console.error('KUNSTLI-INKYBAY-DRAWER error:', error);
      goToCart();
    }
  }

  // InkyBay's official "stay on page" hook (spelling is InkyBay's).
  window.afterInkybayAddToCartActionWithoutRefreash = openDrawer;
})();